import { createContext, useContext } from 'react';

import { SerializedButtonStyles } from 'lib/interfaces/StepsConfig';

/**
 * @private only used as a sub-context in other SST contexts.
 */
export const ButtonSSTStyleContext = createContext<SerializedButtonStyles | undefined>(undefined);

/**
 * For use in pages shared across combined steps, such as Device Handoff.
 * For combined step specific pages, use the combined step's own SST context hook.
 */
export const useButtonSSTStyleContext = () => useContext(ButtonSSTStyleContext);
